<template>
<div>
    <b-modal no-stacking
            v-model="dropoff.isShow"
            centered
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
            hide-footer
            size="xl"
    >
    <template slot="modal-title">
    <div slot="header" class="bg-white border-0">
        <div class="row align-items-center mb-4">
            <div class="col-12">
                <h3 class="mb-0">นำเข้าพัสดุ Drop off</h3>
            </div>
        </div>
        <div class="container-fluid pos card-courier dropoff-box">
            <div class="row">
                <div class="col-lg-12">
                    <h4>สแกนบาร์โค้ดหรือกรอกหมายเลขพัสดุ</h4>
                </div>
            </div>
            <div class="row" v-for="( parcel , key ) in dropoff.parcels" :key="key">
                <div class="col-lg-3">
                    <div class="form-group">
                        <input
                            type="text"
                            :ref="`barcode-${key+1}`"
                            class="form-control m-1"
                            :class="{ 
                                'is-success': parcel.option.error_input.status === true , 
                                'is-invalid': parcel.option.error_input.status === false
                            }" 
                            v-model="parcel.barcode" 
                            placeholder="SP000001735 | EB000001735ST"
                            @input="beforeCheckBarcode( parcel.barcode , key , parcel )"
                        />
                        <div class="loading-box">
                            <div class="loader-autocomplete" v-show="parcel.option.loadingIco"></div>
                        </div>
                        <div 
                            class="error invalid-feedback d-block m-2" 
                            v-if="parcel.option.error_input.status === false"
                        >
                            {{parcel.option.error_input.msg}}
                        </div>
                    </div>
                </div>
                <div class="col-lg-2">
                    <input type="number" class="form-control m-1" v-model="parcel.weight" placeholder="น้ำหนัก (กรัม)" />
                </div>
                <div class="col-lg-2">
                    <input type="number" class="form-control m-1" v-model="parcel.price" placeholder="ค่าบริกาา" />
                </div>
                <div class="col-lg-3">
                    <b-button 
                        variant="primary" 
                        class="m-1" 
                        block
                        :disabled="parcel.option.btnLabel"
                        @click="getLabel( parcel.tracking_code )"
                    >
                        พิมพ์ใบปะหน้า
                    </b-button>
                </div>
                <div class="col-lg-2">
                    <b-button 
                        variant="danger" 
                        class="m-1" 
                        block 
                        :disabled="parcelCheck.nums < 2"
                        @click="removeParcel( key )"
                    >
                        <i class="fas fa-trash"></i>
                    </b-button>
                </div>
            </div>
        </div>
        <div class="text-center m-4">
            <div class="col-lg-12">
                <div class="d-flex justify-content-end">
                    <b-button variant="" @click="resetModal()">ยกเลิก</b-button>
                    <b-button 
                        variant="success" 
                        @click="comfirmOrders()"
                    >
                        ยืนยันข้อมูล
                    </b-button>
                </div>
            </div>
        </div>
    </div>
    </template>
    </b-modal>
</div>
</template>
<script>
export default {
    name: 'DropoffShippop' ,
    props: ['dropoff' , 'confirm' , 'identity'] ,
    data(){
        return {
            inputDefault:   { 
                                barcode: "" , 
                                weight: "" , 
                                price: "5.00" , 
                                num: 1 ,
                                name: "Thailandpost",
                                key: "THP",
                                type: "dropoffShippop",
                                option:{
                                    btnLabel: true,
                                    loadingIco: false,
                                    error_input:{
                                        status: null ,
                                        msg:""
                                    }
                                }
                            },
            btnConfirm: {
                disabled: false
            }
        }
    },
    methods:{
        async beforeCheckBarcode( input  , key  , setting ){

            this.resetInputOption( setting )
            this.handleLoadingIco( setting.option  , true )
            let res = {
                status: false,
                msg: "",
                data:""
            }

            if( input.length < 10 || this.checkTrackingCodeShippop(input) == false ){

                this.validateBarcode( setting , res )
                this.handleLoadingIco( setting.option  , false )

            }else{

                await this.checkBarcodeToShippop( input , setting.option ).then( results => {
                    this.validateBarcode( setting , results )
                    if( results.status == true ){
                        this.addNewparcel( key )
                        setting.tracking_code = results.data.tracking_code
                        setting.courier_tracking_code = results.data.courier_tracking_code
                        setting.key = results.data.courier_code
                        setting.option.btnLabel = false
                    }else{
                        this.validateBarcode( setting , results )
                    }
                })
    
            }

            return res
        },
        checkTrackingCodeShippop( tracking ){

            let format_SP = /^SP[0-9]{9}$/i
            let format_TK = /^[A-Z]{2}[0-9]{9}[A-Z]{2}$/g
            let res = format_SP.test( tracking ) || format_TK.test( tracking )

            return res
        },
        async getLabel( barcode ){
            let response = {
                status: false,
                msg: "",
                data: []
            }
            await this.$http
            .post(
              this.$API_URL + "/dropoff/shippop/label",
              {
                tracking_code: [{ tracking_code : barcode }],
                order_id: null,
                size: this.dropoff.labelSize
              },
              {
                headers: {
                  Token: localStorage.getItem("access_token")
                }
              }
            )
            .then(res => {
                const win = window.open("")
                win.document.write( res.data.data.html )
                setTimeout(() => {
                    win.document.close()
                    win.focus()
                    win.print()
                    // win.close()
                }, 100);

            })
            
            return response

        },
        async checkBarcodeToShippop( barcode  , option ){
            let response = {
                status: false,
                msg: "",
                data: []
            }
            await this.$http
            .post(
              this.$API_URL + "/dropoff/shippop/barcode/check",
              {
                tracking_code: barcode
              },
              {
                headers: {
                  Token: localStorage.getItem("access_token")
                }
              }
            )
            .then(res => {
                let data = res.data
                response.status = data.status

                if( data.status == false ){
                    response.msg = data.error
                }

                if( data.status == true ){
                    response.data = data.data
                }
                this.handleLoadingIco( option  , false )

            })
            
            return response

        },
        addNewparcel( key ){
            key = (+key)+1

            if( this.parcelCheck.nums == key ){

                this.dropoff.parcels.push( JSON.parse(JSON.stringify(this.inputDefault)) )
                let _SELF = this
                this.$nextTick(function () {
                    _SELF.$refs['barcode-'+key][0].focus()
                })
            }
        },
        removeParcel( key ){
            this.dropoff.parcels.splice( key , 1 )
        },
        hideModal(){
            this.dropoff.isShow = false
        },
        resetModal(){
            this.dropoff.parcels = []
            this.dropoff.parcels = [{ ...this.inputDefault }]
            this.hideModal()
        },
        validateOrders(){
            let parcels = this.dropoff.parcels
            let emptyValue = []
            let countError = 0

            parcels.forEach((parcel , index) => {

                if( parcel.barcode == "" || parcel.barcode.length < 1 ){
                    emptyValue.push( index )
                }
                if( parcel.option.error_input.status == false && 
                    ( parcel.barcode != "" || parcel.barcode.length > 1 ) 
                ){
                    countError++
                }
            })

            if( emptyValue.length > 0 ){
                let newParcels = parcels.filter((item,index) => {
                    if( emptyValue.indexOf(index) == -1 ){
                        return true
                    }
                })
                this.$set( this.dropoff , 'parcels', newParcels )
            }

            return {
                'emptyValue' : emptyValue.length,
                'hasError' : countError == 0 ? false : true
            }

        },
        comfirmOrders(){
            let valid = this.validateOrders()

            if( valid.hasError == true ){
                // something
            }else{
                this.confirm()
                this.resetModal()
            }
        },
        handleLoadingIco( loading  , bool = true ){
            loading.loadingIco = bool
        },
        validateBarcode( setting , results ){
            let set_barcode = setting.option.error_input
            if( results.status == true ){
                set_barcode.status = true

            }else{
                set_barcode.status = false
                set_barcode.msg = "หมายเลขพัสดุไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง"
            }
        },
        resetInputOption( setting ){
            setting.key = ""
            setting.option = {
                btnLabel: true,
                loadingIco: false,
                error_input:{
                    status: null ,
                    msg:""
                }
            }

        }
    },
    computed:{
        parcelCheck(){
            let res = {
                nums: 0,
                isObj: false
            }
            if( this.dropoff ){

                res.nums = this.dropoff.parcels.length
                res.isObj = true

            }
            return res
        }
    },
    // watch: {
    //     'dropoff.isShow'( pre  , last ){
    //                         console.log( pre )
    //         if( pre == true ){
    //             // console.log( 'here' )
    //             let SELF = this
    //             // setTimeout(function(){ SELF.$refs['barocde-0'][0].focus() }, 1);
    //             // console.log( SELF.$refs['barocde-0'][0] )
    //             // console.log( this.$root.$on )
    //             this.$nextTick(() => {
    //                 // console.log( SELF.$el )
    //                 // setTimeout(function(){ console.log( SELF.$el.$refs('barocde-0') ) }, 2000);
    //                 // SELF.$refs['barocde-0'].focus()
    //             // setTimeout(function(){ SELF.$refs['barocde-0'].focus() }, 1000);
    //                 // SELF.$nextTick(() => {  SELF.$refs['barocde-0'].focus() })

    //                 // console.log(  SELF.$refs['barocde-0'][0] )
    //                  SELF.$refs['barocde-0'].focus()
    //             })
    //         }
    //     }
    // }

}
</script>
<style scoped>
.dropoff-box{
    padding-top: 2rem;
    padding-bottom: 4rem;
    background:#f6fafd;
    width: 90%;
}
.loader-autocomplete {

    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 100%;
    width: 19px;
    height: 20px;
    animation: spin 1s linear infinite;
}
.loading-box {
  position: absolute;
  top: 2rem;
  right: 15px;
  transform: translate(-50%, -50%);
}
.is-success {
    border-color: #28a745;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>